import dynamic from "next/dynamic";

export const DynamicHomeNewsTicker = dynamic<Record<string, never>>(() =>
  import("scmp-app/components/home/news-ticker").then(module => module.HomeNewsTicker),
);
